export default {
  title: 'Śledź zamówienie',
};
